import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
  UntypedFormBuilder,
  ValidatorFn,
  AbstractControl,
} from "@angular/forms";
import { Router } from "@angular/router";
import { UserserviceService } from "src/app/Services/userservice.service";
import { ToastrService } from "ngx-toastr";
import { Endpoint } from "src/app/shared/endpoints";
import { AuthModalService } from "src/app/Services/auth-modal.service";

@Component({
  selector: "app-change-password",
  templateUrl: "./change-password.component.html",
  styleUrls: ["./change-password.component.scss"],
})
export class ChangePasswordComponent implements OnInit {
  @Output() closeModal = new EventEmitter<void>();

  email: string;
  noResultReturned = false;
  showPassword = false;
  showConfirmPassword = false;
  Code: string;
  Password: string;
  ConfirmPassword: string;
  message: boolean;

  changePasswordForm = new UntypedFormGroup({
    Code: new UntypedFormControl("", Validators.required),
    Password: new UntypedFormControl("", Validators.required),
    ConfirmPassword: new UntypedFormControl("", Validators.required),
    email: new UntypedFormControl("", [Validators.required, Validators.email]),
  });

  constructor(
    public formbuilder: UntypedFormBuilder,
    private userserviceService: UserserviceService,
    private toastr: ToastrService,
    private router: Router,
    public authModalService: AuthModalService
  ) {}

  ngOnInit(): void {
    const storedEmail = localStorage.getItem("userEmail");
    if (storedEmail) {
      try {
        this.email = JSON.parse(storedEmail);
      } catch {
        this.email = storedEmail;
      }
    }

    this.changePasswordForm = this.formbuilder.group({
      Code: new UntypedFormControl("", Validators.required),
      email: new UntypedFormControl(this.email || "", [
        Validators.required,
        Validators.email,
      ]),
      Password: new UntypedFormControl("", [
        Validators.required,
        Validators.minLength(8),
      ]),
      ConfirmPassword: new UntypedFormControl("", [
        Validators.required,
        Validators.minLength(8),
        this.equalto("Password"),
      ]),
    });
  }

  equalto(field_name: string): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      const input = control.value;
      const isValid = control.root.value[field_name] === input;
      if (!isValid) {
        return { equalTo: { isValid } };
      }
      return null;
    };
  }

  close(): void {
    this.closeModal.emit();
    this.authModalService.closeModal();
  }

  openLogin(): void {
    this.showLoginModalOnly();
  }

  signIn() {
    if (this.changePasswordForm.invalid) {
      this.changePasswordForm.markAllAsTouched();
      return;
    }

    this.noResultReturned = true;
    const userModel = {
      EmailAddress: this.email,
      Password: this.Password,
      ConfirmPassword: this.ConfirmPassword,
      ChangePasswordHash: this.Code,
    };

    this.userserviceService
      .changeOldPassword(Endpoint.ChangePassword, userModel)
      .subscribe({
        next: (data) => {
          this.noResultReturned = false;
          if (data) {
            this.toastr.success("Password updated successfully. Please sign in.");
            localStorage.removeItem("userEmail");
            this.showLoginModalOnly();
          } else {
            this.toastr.error(
              "Invalid or expired reset code. Please request a new code."
            );
          }
        },
        error: () => {
          this.noResultReturned = false;
          this.toastr.error(
            "Unable to update password. Check your code and try again."
          );
        },
      });
  }

  /** Show sign-in only in the overlay — never leave /login|/change-password in the page outlet. */
  private showLoginModalOnly(): void {
    this.authModalService.openModal("login");
    const path = (this.router.url || "/").split("?")[0];
    if (path !== "/" && path !== "") {
      this.authModalService.preserveModalOnNextNavigation();
      this.router.navigateByUrl("/", { replaceUrl: true });
    }
  }

  showMessage() {
    if (this.Code == null || this.Code === undefined || this.Code === "") {
      this.message = true;
      this.toastr.warning("Check email for activation code.");
    } else {
      this.message = false;
    }
  }
}
